import React, { useEffect, useState } from "react";
import { Card, ListGroup, Placeholder, Spinner } from "react-bootstrap";
import MainCard from "../../../Components/Cards/MainCard";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import RecentActivityCardSkeleton from "../../../Components/Skeleton/RecentActivityCardSkeleton";

const RecentActivity = () => {
  const [activities, setActivities] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Simulate API Call
  useEffect(() => {
    setTimeout(() => {
      setActivities([
        {
          title: "Agent Approved",
          description: "John Smith - Real Estate Agent",
          time: "2 hours ago",
        },
        {
          title: "Payment Processed",
          description: "$2,450 commission payment",
          time: "4 hours ago",
        },
        {
          title: "Content Published",
          description: "Q2 Market Update blog post",
          time: "6 hours ago",
        },
      ]);
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <MainCard>
      {/* Header */}
      <Card.Header className="fw-bold d-flex justify-content-start align-items-center rounded-3 bg-white border-0 mb-3 fs-4 gap-2 px-0">
        <MdOutlineWatchLater className="text-primary" size={20} />
        Recent Activity
      </Card.Header>

      {/* List Items */}
      <ListGroup className="d-flex flex-column gap-3 pt-2">
        {loading ? (
          // Skeleton Loader
          <RecentActivityCardSkeleton />
        ) : activities && activities.length > 0 ? (
          activities.map((item, index) => (
            <ListGroup.Item
              key={index}
              className="border-0 p-0 d-flex flex-row align-items-start gap-3"
            >
              <div className="d-flex align-items-center gap-2">
                <FaCheckCircle className="text-success" />
              </div>
              <div className="d-flex flex-column small">
                <span className="fw-bold">{item.title}</span>
                <small className="text-muted fw-bold">{item.description}</small>
                <small className="text-secondary">{item.time}</small>
              </div>
            </ListGroup.Item>
          ))
        ) : (
          // Empty state (no data)
          <div className="text-center text-muted py-4">
            <Spinner animation="border" size="sm" className="me-2" />
            No recent activity available
          </div>
        )}
      </ListGroup>
    </MainCard>
  );
};

export default RecentActivity;
